import { render, staticRenderFns } from "./taocibiaozhun.vue?vue&type=template&id=2faab067&scoped=true"
import script from "./taocibiaozhun.vue?vue&type=script&lang=js"
export * from "./taocibiaozhun.vue?vue&type=script&lang=js"
import style0 from "./taocibiaozhun.vue?vue&type=style&index=0&id=2faab067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faab067",
  null
  
)

export default component.exports